<section class="metrics-dialog">
  <mat-dialog-content class="metrics-dialog__content">
    <div class="metrics-dialog__categories">
      <article *ngFor="let categoryKey of categoryKeys" class="metrics-dialog__category">

        <ng-container *ngIf="!isLactateHeartRate(categoryKey)">
          <header class="metrics-dialog__category-header">
            <div class="metrics-dialog__category-info">
              <h2 class="metrics-dialog__category-title">{{ getCategoryDisplayName(categoryKey) }}</h2>
            </div>
          </header>
        </ng-container>

        <div *ngIf="isEnergyContribution(categoryKey)" class="metrics-dialog__three-columns">
          <div class="metrics-dialog__column">
            <label
              *ngFor="let metric of getEnergyContributionGroups().anaerobic"
              class="metrics-dialog__metric"
              [class.metrics-dialog__metric--disabled]="isMetricDisabled(metric.value)">
              <mat-checkbox
                color="primary"
                [checked]="isMetricSelected(metric.value)"
                [disabled]="isMetricDisabled(metric.value)"
                (change)="onMetricToggle(metric.value)"
                class="metrics-dialog__checkbox">
                <span class="metrics-dialog__metric-label">{{ metric.viewValue }}</span>
              </mat-checkbox>
            </label>
          </div>
          <div class="metrics-dialog__column">
            <label
              *ngFor="let metric of getEnergyContributionGroups().aerobic"
              class="metrics-dialog__metric"
              [class.metrics-dialog__metric--disabled]="isMetricDisabled(metric.value)">
              <mat-checkbox
                color="primary"
                [checked]="isMetricSelected(metric.value)"
                [disabled]="isMetricDisabled(metric.value)"
                (change)="onMetricToggle(metric.value)"
                class="metrics-dialog__checkbox">
                <span class="metrics-dialog__metric-label">{{ metric.viewValue }}</span>
              </mat-checkbox>
            </label>
          </div>
          <div class="metrics-dialog__column">
            <label
              *ngFor="let metric of getEnergyContributionGroups().contribution"
              class="metrics-dialog__metric"
              [class.metrics-dialog__metric--disabled]="isMetricDisabled(metric.value)">
              <mat-checkbox
                color="primary"
                [checked]="isMetricSelected(metric.value)"
                [disabled]="isMetricDisabled(metric.value)"
                (change)="onMetricToggle(metric.value)"
                class="metrics-dialog__checkbox">
                <span class="metrics-dialog__metric-label">{{ metric.viewValue }}</span>
              </mat-checkbox>
            </label>
          </div>
        </div>

        <div *ngIf="isSubstrateUtilization(categoryKey)" class="metrics-dialog__three-columns">
          <div class="metrics-dialog__column">
            <label
              *ngFor="let metric of getSubstrateUtilizationGroups().carbohydrates"
              class="metrics-dialog__metric"
              [class.metrics-dialog__metric--disabled]="isMetricDisabled(metric.value)">
              <mat-checkbox
                color="primary"
                [checked]="isMetricSelected(metric.value)"
                [disabled]="isMetricDisabled(metric.value)"
                (change)="onMetricToggle(metric.value)"
                class="metrics-dialog__checkbox">
                <span class="metrics-dialog__metric-label">{{ metric.viewValue }}</span>
              </mat-checkbox>
            </label>
          </div>
          <div class="metrics-dialog__column">
            <label
              *ngFor="let metric of getSubstrateUtilizationGroups().fat"
              class="metrics-dialog__metric"
              [class.metrics-dialog__metric--disabled]="isMetricDisabled(metric.value)">
              <mat-checkbox
                color="primary"
                [checked]="isMetricSelected(metric.value)"
                [disabled]="isMetricDisabled(metric.value)"
                (change)="onMetricToggle(metric.value)"
                class="metrics-dialog__checkbox">
                <span class="metrics-dialog__metric-label">{{ metric.viewValue }}</span>
              </mat-checkbox>
            </label>
          </div>
          <div class="metrics-dialog__column">
            <label
              *ngFor="let metric of getSubstrateUtilizationGroups().total"
              class="metrics-dialog__metric"
              [class.metrics-dialog__metric--disabled]="isMetricDisabled(metric.value)">
              <mat-checkbox
                color="primary"
                [checked]="isMetricSelected(metric.value)"
                [disabled]="isMetricDisabled(metric.value)"
                (change)="onMetricToggle(metric.value)"
                class="metrics-dialog__checkbox">
                <span class="metrics-dialog__metric-label">{{ metric.viewValue }}</span>
              </mat-checkbox>
            </label>
          </div>
        </div>

        <div *ngIf="isPerformanceBenchmarks(categoryKey)" class="metrics-dialog__two-columns">
          <div class="metrics-dialog__column">
            <label
              *ngFor="let metric of getPerformanceBenchmarksColumns().left"
              class="metrics-dialog__metric"
              [class.metrics-dialog__metric--disabled]="isMetricDisabled(metric.value)">
              <mat-checkbox
                color="primary"
                [checked]="isMetricSelected(metric.value)"
                [disabled]="isMetricDisabled(metric.value)"
                (change)="onMetricToggle(metric.value)"
                class="metrics-dialog__checkbox">
                <span class="metrics-dialog__metric-label">{{ metric.viewValue }}</span>
              </mat-checkbox>
            </label>
          </div>
          <div class="metrics-dialog__column">
            <label
              *ngFor="let metric of getPerformanceBenchmarksColumns().right"
              class="metrics-dialog__metric"
              [class.metrics-dialog__metric--disabled]="isMetricDisabled(metric.value)">
              <mat-checkbox
                color="primary"
                [checked]="isMetricSelected(metric.value)"
                [disabled]="isMetricDisabled(metric.value)"
                (change)="onMetricToggle(metric.value)"
                class="metrics-dialog__checkbox">
                <span class="metrics-dialog__metric-label">{{ metric.viewValue }}</span>
              </mat-checkbox>
            </label>
          </div>
        </div>

        <div *ngIf="isLactateHeartRate(categoryKey)" class="metrics-dialog__two-columns">
          <div class="metrics-dialog__column">
            <header class="metrics-dialog__category-header metrics-dialog__category-header--inner">
              <div class="metrics-dialog__category-info">
                <h2 class="metrics-dialog__category-title">{{ getCategoryDisplayName('lactate') }}</h2>
              </div>
            </header>
            <label
              *ngFor="let metric of getMetricsForCategory('lactate')"
              class="metrics-dialog__metric"
              [class.metrics-dialog__metric--disabled]="isMetricDisabled(metric.value)">
              <mat-checkbox
                color="primary"
                [checked]="isMetricSelected(metric.value)"
                [disabled]="isMetricDisabled(metric.value)"
                (change)="onMetricToggle(metric.value)"
                class="metrics-dialog__checkbox">
                <span class="metrics-dialog__metric-label">{{ metric.viewValue }}</span>
              </mat-checkbox>
            </label>
          </div>
          <div class="metrics-dialog__column">
            <header class="metrics-dialog__category-header metrics-dialog__category-header--inner">
              <div class="metrics-dialog__category-info">
                <h2 class="metrics-dialog__category-title">{{ getCategoryDisplayName('heart_rate') }}</h2>
              </div>
            </header>
            <label
              *ngFor="let metric of getMetricsForCategory('heart_rate')"
              class="metrics-dialog__metric"
              [class.metrics-dialog__metric--disabled]="isMetricDisabled(metric.value)">
              <mat-checkbox
                color="primary"
                [checked]="isMetricSelected(metric.value)"
                [disabled]="isMetricDisabled(metric.value)"
                (change)="onMetricToggle(metric.value)"
                class="metrics-dialog__checkbox">
                <span class="metrics-dialog__metric-label">{{ metric.viewValue }}</span>
              </mat-checkbox>
            </label>
          </div>
        </div>

      </article>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="metrics-dialog__actions">
    <div class="metrics-dialog__actions-group">
      <span class="metrics-dialog__selected-counter">{{ selectedCount }} / {{ maxOutputMetrics }}</span>
      <button
        type="button"
        mat-button
        (click)="onDeselectAll()"
        class="metrics-dialog__button">
        Deselect All
      </button>
    </div>
    <div class="metrics-dialog__actions-group">
      <button
        type="button"
        mat-button
        (click)="onCancel()"
        class="metrics-dialog__button">
        Cancel
      </button>
      <button
        type="button"
        mat-raised-button
        color="primary"
        (click)="onApply()"
        class="metrics-dialog__button">
        Apply
      </button>
    </div>
  </mat-dialog-actions>
</section>
